import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  environment: {
    production: boolean;
    basePath: string;
    host: string;
    imageUrl: string;
  } | null = null;

  constructor() {}

  setEnvironment(env: {
    production: boolean;
    basePath: string;
    host: string;
    imageUrl: string;
  }) {
    this.environment = env;
  }

  getEnvironment() {
    return this.environment;
  }
}
